import { Heading, PageContainer, Text } from "@/components/ui"
import { ReactNode, useEffect, useRef } from "react"

type StepHeaderProps = {
  title: string
  description?: ReactNode
}

export function StepHeader({ title, description }: StepHeaderProps) {
  const headingRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    headingRef.current?.focus()
  }, [])

  return (
    <PageContainer as="header" className="pt-6 sm:pt-8 pb-6">
      <Heading
        ref={headingRef}
        level={1}
        size={{ base: "page", sm: "display" }}
        leading="tight"
        tabIndex={-1}
        className="focus:outline-none"
      >
        {title}
      </Heading>
      {description ? (
        <Text size="lg" tone="muted" leading="relaxed" className="mt-3">
          {description}
        </Text>
      ) : null}
    </PageContainer>
  )
}
